import React from 'react'

interface UnderlayProps {
   isOpen?: boolean
}

export function Underlay({ isOpen }: UnderlayProps) {
   return <div />
}
